import { Typography } from "@mui/material"
import { alpha, Box, Theme } from "@mui/system"
import React from "react"
import { FlexBox } from "ui/components/FlexBox"

interface IFormInventoryCpmForecastBarProps {
  label: string
  percent: number
  disabled: boolean
  isMaxBidIncluded: boolean
}

export const FormInventoryCpmForecastBar = React.memo(
  ({ label, percent, disabled, isMaxBidIncluded }: IFormInventoryCpmForecastBarProps): JSX.Element | null => {
    const getBarBackgroundColor = (theme: Theme): string =>
      disabled
        ? theme.palette.text.disabled
        : isMaxBidIncluded
        ? alpha(theme.palette.text.primary2 as string, 0.8)
        : theme.palette.text.primary2
    return (
      <FlexBox jc="start" gap=".4rem" sx={{ width: "100%" }}>
        <Typography
          fontSize=".75rem"
          align="right"
          lineHeight="1.1rem"
          sx={{
            width: "2.2rem",
            maxWidth: "2.2rem",
            minWidth: "2.2rem",
            color: theme => (disabled ? alpha(theme.palette.text.primary2 as string, 0.8) : theme.palette.text.primary2)
          }}>
          {label}
        </Typography>
        <Box
          sx={{
            borderLeft: theme => `1px solid ${getBarBackgroundColor(theme)}`,
            backgroundColor: theme => getBarBackgroundColor(theme),
            width: `${percent}%`,
            height: ".8rem",
            transition: "width 800ms ease"
          }}
        />
        <Typography
          fontSize=".75rem"
          sx={{
            color: theme => (disabled ? alpha(theme.palette.text.primary2 as string, 0.8) : theme.palette.text.primary2)
          }}>{`${percent}%`}</Typography>
      </FlexBox>
    )
  }
)
